import { Directive, HostListener, ElementRef, inject, forwardRef, Renderer2 } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { StringUtilsService } from '../services/string-utils.service';

@Directive({
  selector: '[slugify]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SlugifyDirective),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SlugifyDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class SlugifyDirective implements ControlValueAccessor, Validator {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly stringUtilsService = inject(StringUtilsService);
  private readonly reSlug = /^[a-z0-9]+(?:[-_]*[a-z0-9]+)*$/;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {}

  @HostListener('focusout', ['$event'])
  onFocusOut(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const text = input.value.trim();
    const defaultValue = input.getAttribute('data-default');
    if (!text && this.isValidSlug(defaultValue)) {
      this.renderer.setProperty(this.el.nativeElement, 'value', defaultValue);
      this.onChange(defaultValue);
      this.onTouched();
      return;
    }

    if (this.isValidSlug(text)) {
      this.renderer.setProperty(this.el.nativeElement, 'value', text);
      this.onChange(text);
      this.onTouched();
      return;
    }

    const value = this.stringUtilsService.slugify(text);
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
    this.onChange(value);
    this.onTouched();
  }

  //for now we don't check slug format, just check if the text is not empty
  private isValidSlug(text: string): boolean {
    if (!text) {
      return false;
    }
    return text.trim()?.length > 0;
    //return this.reSlug.test(text);
  }

  // ControlValueAccessor implementation
  writeValue(value: any): void {
    this.renderer.setProperty(this.el.nativeElement, 'value', value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const result = this.isValidSlug(control.value) ? null : { slugify: true };
    return result;
  }
}
